export default __webpack_public_path__ + "locales/sq-AL/CreateEditRoomDialog.json?hash=0990856b2a839bcd672b642d91ee0c4f";